import { lazy } from 'react';
import { RouteObject, Navigate } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AuthPage = lazy(() => import('../pages/auth/page'));
const DashboardPage = lazy(() => import('../pages/dashboard/page'));
const AdminLoginPage = lazy(() => import('../pages/admin/login/page'));
const AdminDashboardPage = lazy(() => import('../pages/admin/dashboard/page'));
const PrivacyPage = lazy(() => import('../pages/legal/privacy/page'));
const TermsPage = lazy(() => import('../pages/legal/terms/page'));
const ImprintPage = lazy(() => import('../pages/legal/imprint/page'));
const DisclaimerPage = lazy(() => import('../pages/legal/disclaimer/page'));
const SubscriptionTermsPage = lazy(() => import('../pages/legal/subscription-terms/page'));
const BillingSuccessPage = lazy(() => import('../pages/billing/success/page'));
const TrialPage = lazy(() => import('../pages/trial/page'));
const PlansPage = lazy(() => import('../pages/plans/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const BuilderReportPage = lazy(() => import('../pages/builderReport/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/auth',
    element: <AuthPage />,
  },
  {
    path: '/dashboard',
    element: <DashboardPage />,
  },
  {
    path: '/trial',
    element: <TrialPage />,
  },
  {
    path: '/plans',
    element: <PlansPage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/dashboard/report/:ideaId',
    element: <BuilderReportPage />,
  },
  {
    path: '/admin',
    element: <Navigate to="/admin/login" replace />,
  },
  {
    path: '/admin/login',
    element: <AdminLoginPage />,
  },
  {
    path: '/admin/dashboard',
    element: <AdminDashboardPage />,
  },
  {
    path: '/privacy',
    element: <PrivacyPage />,
  },
  {
    path: '/terms',
    element: <TermsPage />,
  },
  {
    path: '/imprint',
    element: <ImprintPage />,
  },
  {
    path: '/disclaimer',
    element: <DisclaimerPage />,
  },
  {
    path: '/subscription-terms',
    element: <SubscriptionTermsPage />,
  },
  {
    path: '/billing/success',
    element: <BillingSuccessPage />,
  },
  // Legacy `/legal/*` aliases — historic links from the auth signup form
  // (and bookmarks elsewhere) still point here. Map them to the canonical
  // routes so the links don't 404 after this refactor.
  { path: '/legal/terms', element: <TermsPage /> },
  { path: '/legal/privacy', element: <PrivacyPage /> },
  { path: '/legal/disclaimer', element: <DisclaimerPage /> },
  { path: '/legal/imprint', element: <ImprintPage /> },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
